import { MatDialogConfig } from '@angular/material/dialog';

/**
 * Create a default dialog configuration object.
 *
 * @typeparam T — The type for the data object.
 */
export class DefaultDialogConfig<D = any> extends MatDialogConfig<D> {
  public backdropClass = 'custom-dialog-backdrop';
  public panelClass = 'custom-dialog-overlay-pane';
  public maxWidth: string | number = '90vw';

  /**
   * Create a new dialog config with the default configuration.
   * @param config Customised configuration
   */
  constructor(config?: MatDialogConfig<D>) {
    super();
    if (config) {
      Object.assign(this, config);
    }
  }
}
